export default {
  title: {
    management: 'Interview/Rating Questionnaire Management',
    questionnaire: {
      add: 'Add Questionnaire',
      edit: 'Edit Questionnaire',
      view: 'View Questionnaire'
    }
  },
  menu: 'Interview/Rating Questionnaire Management',
  tab: {
    questionnaire: 'Questionnaire',
    question: 'Question',
    scoreScale: 'Response Scale Setting'
  },
  label: {
    questionnaireName: 'Questionnaire Name',
    questionnaireChineseName: 'Questionnaire Chinese Name',
    questionnaireEnglishName: 'Questionnaire English Name',
    company: 'Company',
    scale: 'Response Scale',
    hmRatingsPrivate: 'Private Rating',
    hideRatingsFromHm: 'Private Rating',
    status: 'Status',
    timesUsed: 'Times Used',
    lastUpdate: 'Last Update',
    question: 'Question',
    type: 'Type',
    required: 'Required',
    scoreWeight: 'Score Weight (%)',
    questionType: 'Question Type',
    chineseTitle: 'Chinese Title',
    englishTitle: 'English Title',
    chineseOptions: 'Chinese Options',
    englishOptions: 'English Options',
    locked: 'Locked'
  },
  btn: {
    view: 'View',
    copy: 'Copy',
    addQuestion: 'Add a Question',
    addNewQuestion: 'Add',
    copyQuestionnaire: 'Copy as a new questionnaire',
    all: 'All',
    rating: 'Rating',
    text: 'Text',
    single: 'Single-select',
    multiple: 'Multi-select',
    date: 'Date'
  },
  placeholder: {
    company: 'All Companies',
    status: 'All Status',
    type: 'Type',
    questionType: 'Please select question type',
    options: 'Input your response options, or paste from Excel.',
    searchQuestion: 'Search Question'
  },
  questionType: {
    rating: 'Rating Question',
    text: 'Text Question',
    single: 'Single-select Question',
    multiple: 'Multi-select Question',
    date: 'Date Question'
  },
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },
  questionnaireStatus: {
    open: 'Enabled',
    closed: 'Disabled'
  },
  hmRatings: {
    private: 'Private',
    public: 'Public'
  },
  dialog: {
    addQuestion: 'Add Question',
    editQuestion: 'Edit Question',
    viewQuestion: 'View Question'
  },
  message: {
    selectedQuestion: '{count} question(s) selected',
    lockedQuestionnaire: 'This questionnaire is live. You may only edit the score weight, privacy settings and required response settings.',
    questionRequired: 'Please add at least one question before saving.',
    weightTotalInvalid: 'The total score weight must equal 100%.',
    scaleRequiredForRating: 'Please select the response scale.',
    saveBeforeCopy: 'Please save this questionnaire before copying it.',
    hasDuplicateQuestionnaire: 'Oops, seems this questionnaire name already exists, please choose another.'
  }
}
